import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

const Breadcrumbs = ({ breadcrumbs = [] }) => {
  if (!breadcrumbs.length) return null;

  return (
    <div class={style.breadcrumbWrapper}>
      <ul class={style.breadcrumbs}>
        {breadcrumbs.map(item => (
          <li>
            <Link
              activeClassName={style.active}
              class={style.link}
              href={item.link}
            >
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./components/breadcrumbs/index.js